import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import NavigationBar from './Components/NavigationBar';
import GeneralInfo from './Components/GeneralInfo';
import Publications from './Pages/Publications';
import About from './Pages/About';
import Services from './Pages/Services';
import Talks from './Pages/Talks';

import 'typeface-roboto';
import 'typeface-nunito';
import 'typeface-open-sans';
import '../sass/style.scss';


const HomeDisplay = () => (<div>
    <About/>

        <Publications showTitle={true} grouped={false}/>
    </div>)


const navigationItems = [
    { value: "Home", id: 0, component: HomeDisplay},
    // { value: "About", id: 1, component: About},
    { value: "Service", id: 2, component: Services},
    { value: "Publications", id: 3, component: Publications},

    { value: "Talks", id: 4, component: Talks},
];

const App = () => {

    const [currentPage, updateCurrentPage] = useState(0);

    const CurrentPageComponent = currentPage !== -1 ? 
                                    navigationItems.filter(d => d.id === currentPage)[0].component
                                    : '';

    return (
        <div className='main-page-container'> 
            <div className='left-bar'>
                <GeneralInfo />
            </div>
            <div className='right-bar'>
                <div className='navigation-bar-container'>
                    <NavigationBar 
                        items={navigationItems} 
                        selected={currentPage} 
                        onChange={(i) => {
                            updateCurrentPage(i);
                        }}/> 
                </div>
                <div className='current-page'>
                    {currentPage === -1 ? 
                        <HomeDisplay />
                    : <CurrentPageComponent />}
                    
                    {/* <About />
                    <Publications /> */}
                </div>
            </div>
        </div>
    );
};


ReactDOM.render(<App />, document.body)

